/**
 * Automatically generated file. Do not edit.
 */

import icons__algebra_readiness from './icons/algebra-readiness.svg';
import icons__alts__gym_add from './icons/alts/gym-add.svg';
import icons__alts__gym_dec_add from './icons/alts/gym-dec-add.svg';
import icons__alts__gym_dec_div from './icons/alts/gym-dec-div.svg';
import icons__alts__gym_dec_mul from './icons/alts/gym-dec-mul.svg';
import icons__alts__gym_dec_sub from './icons/alts/gym-dec-sub.svg';
import icons__alts__gym_dec from './icons/alts/gym-dec.svg';
import icons__alts__gym_div from './icons/alts/gym-div.svg';
import icons__alts__gym_frc_add from './icons/alts/gym-frc-add.svg';
import icons__alts__gym_frc_div from './icons/alts/gym-frc-div.svg';
import icons__alts__gym_frc_mul from './icons/alts/gym-frc-mul.svg';
import icons__alts__gym_frc_sub from './icons/alts/gym-frc-sub.svg';
import icons__alts__gym_frc from './icons/alts/gym-frc.svg';
import icons__alts__gym_int_add from './icons/alts/gym-int-add.svg';
import icons__alts__gym_int_div from './icons/alts/gym-int-div.svg';
import icons__alts__gym_int_mul from './icons/alts/gym-int-mul.svg';
import icons__alts__gym_int_sub from './icons/alts/gym-int-sub.svg';
import icons__alts__gym_int from './icons/alts/gym-int.svg';
import icons__alts__gym_k2_add from './icons/alts/gym-k2-add.svg';
import icons__alts__gym_k2_sub from './icons/alts/gym-k2-sub.svg';
import icons__alts__gym_mul from './icons/alts/gym-mul.svg';
import icons__alts__gym_num_add from './icons/alts/gym-num-add.svg';
import icons__alts__gym_num_div from './icons/alts/gym-num-div.svg';
import icons__alts__gym_num_mul from './icons/alts/gym-num-mul.svg';
import icons__alts__gym_num_sub from './icons/alts/gym-num-sub.svg';
import icons__alts__gym_num from './icons/alts/gym-num.svg';
import icons__alts__gym_sub from './icons/alts/gym-sub.svg';
import icons__alts__jtf_add from './icons/alts/jtf-add.svg';
import icons__alts__jtf_div from './icons/alts/jtf-div.svg';
import icons__alts__jtf_mul from './icons/alts/jtf-mul.svg';
import icons__alts__jtf_sub from './icons/alts/jtf-sub.svg';
import icons__alts__ss1_g1 from './icons/alts/ss1-g1.svg';
import icons__alts__ss1_g2 from './icons/alts/ss1-g2.svg';
import icons__alts__ss1_g3 from './icons/alts/ss1-g3.svg';
import icons__alts__ss2_g1 from './icons/alts/ss2-g1.svg';
import icons__alts__ss2_g2 from './icons/alts/ss2-g2.svg';
import icons__alts__ss2_g3 from './icons/alts/ss2-g3.svg';
import icons__alts__ss3_g1 from './icons/alts/ss3-g1.svg';
import icons__alts__ss3_g2 from './icons/alts/ss3-g2.svg';
import icons__alts__ss3_g3 from './icons/alts/ss3-g3.svg';
import icons__alts__ss4_g1 from './icons/alts/ss4-g1.svg';
import icons__alts__ss4_g2 from './icons/alts/ss4-g2.svg';
import icons__alts__ss4_g3 from './icons/alts/ss4-g3.svg';
import icons__alts__ss5_g1 from './icons/alts/ss5-g1.svg';
import icons__alts__ss5_g2 from './icons/alts/ss5-g2.svg';
import icons__alts__ss5_g3 from './icons/alts/ss5-g3.svg';
import icons__alts__ss6_g1 from './icons/alts/ss6-g1.svg';
import icons__alts__ss6_g2 from './icons/alts/ss6-g2.svg';
import icons__alts__ss6_g3 from './icons/alts/ss6-g3.svg';
import icons__alts__ss7_g1 from './icons/alts/ss7-g1.svg';
import icons__alts__ss7_g2 from './icons/alts/ss7-g2.svg';
import icons__alts__ss7_g3 from './icons/alts/ss7-g3.svg';
import icons__alts__ss8_g1 from './icons/alts/ss8-g1.svg';
import icons__alts__ss8_g2 from './icons/alts/ss8-g2.svg';
import icons__alts__ss8_g3 from './icons/alts/ss8-g3.svg';
import icons__alts__vif_add from './icons/alts/vif-add.svg';
import icons__alts__vif_div from './icons/alts/vif-div.svg';
import icons__alts__vif_mul from './icons/alts/vif-mul.svg';
import icons__alts__vif_sub from './icons/alts/vif-sub.svg';
import icons__compass from './icons/compass.svg';
import icons__fim from './icons/fim.svg';
import icons__fractions_fest from './icons/fractions-fest.svg';
import icons__games__24_wheels from './icons/games/24-wheels.svg';
import icons__games__3_moves_to_0_quantum from './icons/games/3-moves-to-0-quantum.svg';
import icons__games__3_moves_to_0 from './icons/games/3-moves-to-0.svg';
import icons__games__3_to_9_add from './icons/games/3-to-9-add.svg';
import icons__games__3_to_9_sub from './icons/games/3-to-9-sub.svg';
import icons__games__abc from './icons/games/abc.svg';
import icons__games__algebra_mol from './icons/games/algebra-mol.svg';
import icons__games__algebra_tiles from './icons/games/algebra-tiles.svg';
import icons__games__alphabet from './icons/games/alphabet.svg';
import icons__games__area_perimeter from './icons/games/area-perimeter.svg';
import icons__games__building_sentences from './icons/games/building-sentences.svg';
import icons__games__cb_sounds from './icons/games/cb-sounds.svg';
import icons__games__change_one_letter from './icons/games/change-one-letter.svg';
import icons__games__consonant_blends from './icons/games/consonant-blends.svg';
import icons__games__decimal_tiles from './icons/games/decimal-tiles.svg';
import icons__games__decimals_mol from './icons/games/decimals-mol.svg';
import icons__games__deep_seaquence_lvl1 from './icons/games/deep-seaquence-lvl1.svg';
import icons__games__deep_seaquence_lvl2 from './icons/games/deep-seaquence-lvl2.svg';
import icons__games__deep_seaquence from './icons/games/deep-seaquence.svg';
import icons__games__early_algebra_tiles from './icons/games/early-algebra-tiles.svg';
import icons__games__elementary_algebra_tiles from './icons/games/elementary-algebra-tiles.svg';
import icons__games__epic_circles from './icons/games/epic-circles.svg';
import icons__games__equal_length from './icons/games/equal-length.svg';
import icons__games__equal_pay_dollars from './icons/games/equal-pay-dollars.svg';
import icons__games__equal_pay_rupees from './icons/games/equal-pay-rupees.svg';
import icons__games__equal_pay from './icons/games/equal-pay.svg';
import icons__games__equal_time from './icons/games/equal-time.svg';
import icons__games__equal_weight from './icons/games/equal-weight.svg';
import icons__games__equivalent_fraction_tiles from './icons/games/equivalent-fraction-tiles.svg';
import icons__games__equivalents_lvl1 from './icons/games/equivalents-lvl1.svg';
import icons__games__equivalents_lvl2 from './icons/games/equivalents-lvl2.svg';
import icons__games__equivalents from './icons/games/equivalents.svg';
import icons__games__estimation_dec_epic from './icons/games/estimation-dec-epic.svg';
import icons__games__estimation_dec_newb from './icons/games/estimation-dec-newb.svg';
import icons__games__estimation_dec from './icons/games/estimation-dec.svg';
import icons__games__estimation_epic from './icons/games/estimation-epic.svg';
import icons__games__estimation_newb from './icons/games/estimation-newb.svg';
import icons__games__estimation from './icons/games/estimation.svg';
import icons__games__exponent_tiles from './icons/games/exponent-tiles.svg';
import icons__games__factor_wheels_ct from './icons/games/factor-wheels-ct.svg';
import icons__games__factor_wheels from './icons/games/factor-wheels.svg';
import icons__games__finding_words_4x4 from './icons/games/finding-words-4x4.svg';
import icons__games__first_in_tens_add from './icons/games/first-in-tens-add.svg';
import icons__games__first_in_tens_sub from './icons/games/first-in-tens-sub.svg';
import icons__games__first_to_twenty_add from './icons/games/first-to-twenty-add.svg';
import icons__games__first_to_twenty_sub from './icons/games/first-to-twenty-sub.svg';
import icons__games__five_at_a_time from './icons/games/five-at-a-time.svg';
import icons__games__fraction_tiles from './icons/games/fraction-tiles.svg';
import icons__games__fraction_wheels from './icons/games/fraction-wheels.svg';
import icons__games__fractions_mol from './icons/games/fractions-mol.svg';
import icons__games__gems_to_zero from './icons/games/gems-to-zero.svg';
import icons__games__geometry_tiles from './icons/games/geometry-tiles.svg';
import icons__games__grand_slam_add_sub from './icons/games/grand-slam-add-sub.svg';
import icons__games__grand_slam_alg from './icons/games/grand-slam-alg.svg';
import icons__games__grand_slam_dec_add_sub from './icons/games/grand-slam-dec-add-sub.svg';
import icons__games__grand_slam_dec_all from './icons/games/grand-slam-dec-all.svg';
import icons__games__grand_slam_dec_mul_div from './icons/games/grand-slam-dec-mul-div.svg';
import icons__games__grand_slam_dec from './icons/games/grand-slam-dec.svg';
import icons__games__grand_slam_frc_add_sub from './icons/games/grand-slam-frc-add-sub.svg';
import icons__games__grand_slam_frc_all from './icons/games/grand-slam-frc-all.svg';
import icons__games__grand_slam_frc_mul_div from './icons/games/grand-slam-frc-mul-div.svg';
import icons__games__grand_slam_frc from './icons/games/grand-slam-frc.svg';
import icons__games__grand_slam_integers from './icons/games/grand-slam-integers.svg';
import icons__games__grand_slam_mul_div from './icons/games/grand-slam-mul-div.svg';
import icons__games__hex_factor_lvl1 from './icons/games/hex-factor-lvl1.svg';
import icons__games__hex_factor_lvl2 from './icons/games/hex-factor-lvl2.svg';
import icons__games__high_fq_words from './icons/games/high-fq-words.svg';
import icons__games__integer_tiles from './icons/games/integer-tiles.svg';
import icons__games__into_the_vortex from './icons/games/into-the-vortex.svg';
import icons__games__jennies_jewels from './icons/games/jennies-jewels.svg';
import icons__games__jeweled_tiles from './icons/games/jeweled-tiles.svg';
import icons__games__k2_before_and_after from './icons/games/k2-before-and-after.svg';
import icons__games__k2_ct from './icons/games/k2-ct.svg';
import icons__games__k2_five_at_a_time from './icons/games/k2-five-at-a-time.svg';
import icons__games__k2_four_at_a_time from './icons/games/k2-four-at-a-time.svg';
import icons__games__k2_how_many from './icons/games/k2-how-many.svg';
import icons__games__k2_jennies_jewels from './icons/games/k2-jennies-jewels.svg';
import icons__games__k2_misfits_num_ct from './icons/games/k2-misfits-num-ct.svg';
import icons__games__k2_misfits_num from './icons/games/k2-misfits-num.svg';
import icons__games__k2_misfits from './icons/games/k2-misfits.svg';
import icons__games__k2_missing_icons_ct from './icons/games/k2-missing-icons-ct.svg';
import icons__games__k2_mol from './icons/games/k2-mol.svg';
import icons__games__k2_monus_path_ct from './icons/games/k2-monus-path-ct.svg';
import icons__games__k2_pundis_puzzle_ct from './icons/games/k2-pundis-puzzle-ct.svg';
import icons__games__k2_pundis_puzzle from './icons/games/k2-pundis-puzzle.svg';
import icons__games__k2_rps_ct from './icons/games/k2-rps-ct.svg';
import icons__games__k2_rps from './icons/games/k2-rps.svg';
import icons__games__k2_skip_game from './icons/games/k2-skip-game.svg';
import icons__games__k2_triplets from './icons/games/k2-triplets.svg';
import icons__games__k2_undo from './icons/games/k2-undo.svg';
import icons__games__k2_what_belongs_ct from './icons/games/k2-what-belongs-ct.svg';
import icons__games__letter_memory from './icons/games/letter-memory.svg';
import icons__games__link_n_lock_as from './icons/games/link-n-lock-as.svg';
import icons__games__link_n_lock_frc from './icons/games/link-n-lock-frc.svg';
import icons__games__link_n_lock_jewels from './icons/games/link-n-lock-jewels.svg';
import icons__games__link_n_lock_md from './icons/games/link-n-lock-md.svg';
import icons__games__link_n_lock_mosaic from './icons/games/link-n-lock-mosaic.svg';
import icons__games__making_change_rupees from './icons/games/making-change-rupees.svg';
import icons__games__making_change from './icons/games/making-change.svg';
import icons__games__matching_letters from './icons/games/matching-letters.svg';
import icons__games__misfits_37_num from './icons/games/misfits-37-num.svg';
import icons__games__misfits_37 from './icons/games/misfits-37.svg';
import icons__games__misfits_dec from './icons/games/misfits-dec.svg';
import icons__games__misfits_frc from './icons/games/misfits-frc.svg';
import icons__games__misfits_master from './icons/games/misfits-master.svg';
import icons__games__misfits_newb from './icons/games/misfits-newb.svg';
import icons__games__misfits_num from './icons/games/misfits-num.svg';
import icons__games__misfits_spelling from './icons/games/misfits-spelling.svg';
import icons__games__misfits from './icons/games/misfits.svg';
import icons__games__missing_letters from './icons/games/missing-letters.svg';
import icons__games__mol_lvl1 from './icons/games/mol-lvl1.svg';
import icons__games__mol_lvl2 from './icons/games/mol-lvl2.svg';
import icons__games__mol from './icons/games/mol.svg';
import icons__games__money_tiles from './icons/games/money-tiles.svg';
import icons__games__monujis_path from './icons/games/monujis-path.svg';
import icons__games__monus_path from './icons/games/monus-path.svg';
import icons__games__number_circles from './icons/games/number-circles.svg';
import icons__games__numbers_k2 from './icons/games/numbers-k2.svg';
import icons__games__order_of_operations_tiles from './icons/games/order-of-operations-tiles.svg';
import icons__games__passing_time from './icons/games/passing-time.svg';
import icons__games__pattern_power from './icons/games/pattern-power.svg';
import icons__games__pattern_puzzle from './icons/games/pattern-puzzle.svg';
import icons__games__phonemes_alpha from './icons/games/phonemes-alpha.svg';
import icons__games__phonemes_pi from './icons/games/phonemes-pi.svg';
import icons__games__pk_before_and_after from './icons/games/pk-before-and-after.svg';
import icons__games__pk_how_many from './icons/games/pk-how-many.svg';
import icons__games__pk_memory_tiles from './icons/games/pk-memory-tiles.svg';
import icons__games__pk_missing_icons from './icons/games/pk-missing-icons.svg';
import icons__games__pk_mol from './icons/games/pk-mol.svg';
import icons__games__pk_three_at_a_time from './icons/games/pk-three-at-a-time.svg';
import icons__games__pundis_puzzle from './icons/games/pundis-puzzle.svg';
import icons__games__quantum_algebra from './icons/games/quantum-algebra.svg';
import icons__games__rhyme_time from './icons/games/rhyme-time.svg';
import icons__games__rps_master from './icons/games/rps-master.svg';
import icons__games__rps_newb_ct from './icons/games/rps-newb-ct.svg';
import icons__games__rps from './icons/games/rps.svg';
import icons__games__see_3 from './icons/games/see-3.svg';
import icons__games__shape_shuffle from './icons/games/shape-shuffle.svg';
import icons__games__shapes_k2 from './icons/games/shapes-k2.svg';
import icons__games__skip_game from './icons/games/skip-game.svg';
import icons__games__sound_of_letters from './icons/games/sound-of-letters.svg';
import icons__games__speed_shuffle from './icons/games/speed-shuffle.svg';
import icons__games__sub_all from './icons/games/sub-all.svg';
import icons__games__ten_wheels_elite from './icons/games/ten-wheels-elite.svg';
import icons__games__ten_wheels from './icons/games/ten-wheels.svg';
import icons__games__the_hex_factor from './icons/games/the-hex-factor.svg';
import icons__games__time_more_or_less from './icons/games/time-more-or-less.svg';
import icons__games__touchdown_100_add from './icons/games/touchdown-100-add.svg';
import icons__games__touchdown_100_sub from './icons/games/touchdown-100-sub.svg';
import icons__games__undo_fractions from './icons/games/undo-fractions.svg';
import icons__games__verb_tenses from './icons/games/verb-tenses.svg';
import icons__games__vif_tiles from './icons/games/vif-tiles.svg';
import icons__games__word_wheels from './icons/games/word-wheels.svg';
import icons__games__write_a_sentence from './icons/games/write-a-sentence.svg';
import icons__games__xtreme_algebra from './icons/games/xtreme-algebra.svg';
import icons__games__xyz_shuffle from './icons/games/xyz-shuffle.svg';
import icons__games__zero_sum_newb from './icons/games/zero-sum-newb.svg';
import icons__games__zero_sum from './icons/games/zero-sum.svg';
import icons__gym_numbers__dec__0_05 from './icons/gym-numbers/dec/0-05.svg';
import icons__gym_numbers__dec__0_1 from './icons/gym-numbers/dec/0-1.svg';
import icons__gym_numbers__dec__0_2 from './icons/gym-numbers/dec/0-2.svg';
import icons__gym_numbers__dec__0_25 from './icons/gym-numbers/dec/0-25.svg';
import icons__gym_numbers__dec__0_3 from './icons/gym-numbers/dec/0-3.svg';
import icons__gym_numbers__dec__0_4 from './icons/gym-numbers/dec/0-4.svg';
import icons__gym_numbers__dec__0_5 from './icons/gym-numbers/dec/0-5.svg';
import icons__gym_numbers__dec__0_6 from './icons/gym-numbers/dec/0-6.svg';
import icons__gym_numbers__dec__0_7 from './icons/gym-numbers/dec/0-7.svg';
import icons__gym_numbers__dec__0_75 from './icons/gym-numbers/dec/0-75.svg';
import icons__gym_numbers__dec__0_8 from './icons/gym-numbers/dec/0-8.svg';
import icons__gym_numbers__dec__0_9 from './icons/gym-numbers/dec/0-9.svg';
import icons__gym_numbers__frc__1_16 from './icons/gym-numbers/frc/1-16.svg';
import icons__gym_numbers__frc__1_2 from './icons/gym-numbers/frc/1-2.svg';
import icons__gym_numbers__frc__1_3 from './icons/gym-numbers/frc/1-3.svg';
import icons__gym_numbers__frc__1_32 from './icons/gym-numbers/frc/1-32.svg';
import icons__gym_numbers__frc__1_4 from './icons/gym-numbers/frc/1-4.svg';
import icons__gym_numbers__frc__1_5 from './icons/gym-numbers/frc/1-5.svg';
import icons__gym_numbers__frc__1_8 from './icons/gym-numbers/frc/1-8.svg';
import icons__gym_numbers__frc__2_3 from './icons/gym-numbers/frc/2-3.svg';
import icons__gym_numbers__frc__3_4 from './icons/gym-numbers/frc/3-4.svg';
import icons__gym_numbers__frc__3_8 from './icons/gym-numbers/frc/3-8.svg';
import icons__gym_numbers__frc__5_8 from './icons/gym-numbers/frc/5-8.svg';
import icons__gym_numbers__frc__7_8 from './icons/gym-numbers/frc/7-8.svg';
import icons__gym_numbers__int__neg_1 from './icons/gym-numbers/int/neg-1.svg';
import icons__gym_numbers__int__neg_10 from './icons/gym-numbers/int/neg-10.svg';
import icons__gym_numbers__int__neg_11 from './icons/gym-numbers/int/neg-11.svg';
import icons__gym_numbers__int__neg_12 from './icons/gym-numbers/int/neg-12.svg';
import icons__gym_numbers__int__neg_2 from './icons/gym-numbers/int/neg-2.svg';
import icons__gym_numbers__int__neg_3 from './icons/gym-numbers/int/neg-3.svg';
import icons__gym_numbers__int__neg_4 from './icons/gym-numbers/int/neg-4.svg';
import icons__gym_numbers__int__neg_5 from './icons/gym-numbers/int/neg-5.svg';
import icons__gym_numbers__int__neg_6 from './icons/gym-numbers/int/neg-6.svg';
import icons__gym_numbers__int__neg_7 from './icons/gym-numbers/int/neg-7.svg';
import icons__gym_numbers__int__neg_8 from './icons/gym-numbers/int/neg-8.svg';
import icons__gym_numbers__int__neg_9 from './icons/gym-numbers/int/neg-9.svg';
import icons__gym_numbers__num__1 from './icons/gym-numbers/num/1.svg';
import icons__gym_numbers__num__10 from './icons/gym-numbers/num/10.svg';
import icons__gym_numbers__num__11 from './icons/gym-numbers/num/11.svg';
import icons__gym_numbers__num__12 from './icons/gym-numbers/num/12.svg';
import icons__gym_numbers__num__2 from './icons/gym-numbers/num/2.svg';
import icons__gym_numbers__num__3 from './icons/gym-numbers/num/3.svg';
import icons__gym_numbers__num__4 from './icons/gym-numbers/num/4.svg';
import icons__gym_numbers__num__5 from './icons/gym-numbers/num/5.svg';
import icons__gym_numbers__num__6 from './icons/gym-numbers/num/6.svg';
import icons__gym_numbers__num__7 from './icons/gym-numbers/num/7.svg';
import icons__gym_numbers__num__8 from './icons/gym-numbers/num/8.svg';
import icons__gym_numbers__num__9 from './icons/gym-numbers/num/9.svg';
import icons__ks_categories__1 from './icons/ks-categories/1.svg';
import icons__ks_categories__2 from './icons/ks-categories/2.svg';
import icons__ks_categories__3 from './icons/ks-categories/3.svg';
import icons__ks_categories__4 from './icons/ks-categories/4.svg';
import icons__ks_categories__5 from './icons/ks-categories/5.svg';
import icons__ks_categories__6 from './icons/ks-categories/6.svg';
import icons__ks_categories__7 from './icons/ks-categories/7.svg';
import icons__ks_categories__8 from './icons/ks-categories/8.svg';
import icons__ks_categories__9 from './icons/ks-categories/9.svg';
import icons__lock from './icons/lock.svg';
import icons__math_objectives from './icons/math-objectives.svg';
import icons__modes__dec from './icons/modes/dec.svg';
import icons__modes__frc from './icons/modes/frc.svg';
import icons__modes__int from './icons/modes/int.svg';
import icons__modes__k2 from './icons/modes/k2.svg';
import icons__modes__num from './icons/modes/num.svg';
import icons__modules__bonus__bonus_1 from './icons/modules/bonus/bonus-1.svg';
import icons__modules__bonus__bonus_2 from './icons/modules/bonus/bonus-2.svg';
import icons__modules__bonus__bonus_3 from './icons/modules/bonus/bonus-3.svg';
import icons__modules__bonus__bonus_4 from './icons/modules/bonus/bonus-4.svg';
import icons__modules__bonus__bonus_5 from './icons/modules/bonus/bonus-5.svg';
import icons__modules__bonus__bonus_6 from './icons/modules/bonus/bonus-6.svg';
import icons__modules__bonus__bonus_7 from './icons/modules/bonus/bonus-7.svg';
import icons__modules__bonus__bonus_8 from './icons/modules/bonus/bonus-8.svg';
import icons__modules__bonus from './icons/modules/bonus.svg';
import icons__modules__ct from './icons/modules/ct.svg';
import icons__modules__gyms from './icons/modules/gyms.svg';
import icons__modules__jtf from './icons/modules/jtf.svg';
import icons__modules__k2__first_in_reading__letters from './icons/modules/k2/first-in-reading/letters.svg';
import icons__modules__k2__first_in_reading__sentences from './icons/modules/k2/first-in-reading/sentences.svg';
import icons__modules__k2__first_in_reading__words from './icons/modules/k2/first-in-reading/words.svg';
import icons__modules__k2__first_in_reading from './icons/modules/k2/first-in-reading.svg';
import icons__modules__k2__pre_k from './icons/modules/k2/pre-k.svg';
import icons__modules__k2 from './icons/modules/k2.svg';
import icons__modules__ks__ks_1 from './icons/modules/ks/ks-1.svg';
import icons__modules__ks__ks_2 from './icons/modules/ks/ks-2.svg';
import icons__modules__ks__ks_3 from './icons/modules/ks/ks-3.svg';
import icons__modules__ks__ks_4 from './icons/modules/ks/ks-4.svg';
import icons__modules__ks__ks_5 from './icons/modules/ks/ks-5.svg';
import icons__modules__ks__ks_6 from './icons/modules/ks/ks-6.svg';
import icons__modules__ks__ks_7 from './icons/modules/ks/ks-7.svg';
import icons__modules__ks__ks_8 from './icons/modules/ks/ks-8.svg';
import icons__modules__ks from './icons/modules/ks.svg';
import icons__modules__mw from './icons/modules/mw.svg';
import icons__modules__ss__g1 from './icons/modules/ss/g1.svg';
import icons__modules__ss__g2 from './icons/modules/ss/g2.svg';
import icons__modules__ss__g3 from './icons/modules/ss/g3.svg';
import icons__modules__ss__ss_1 from './icons/modules/ss/ss-1.svg';
import icons__modules__ss__ss_2 from './icons/modules/ss/ss-2.svg';
import icons__modules__ss__ss_3 from './icons/modules/ss/ss-3.svg';
import icons__modules__ss__ss_4 from './icons/modules/ss/ss-4.svg';
import icons__modules__ss__ss_5 from './icons/modules/ss/ss-5.svg';
import icons__modules__ss__ss_6 from './icons/modules/ss/ss-6.svg';
import icons__modules__ss__ss_7 from './icons/modules/ss/ss-7.svg';
import icons__modules__ss__ss_8 from './icons/modules/ss/ss-8.svg';
import icons__modules__ss from './icons/modules/ss.svg';
import icons__modules__vif from './icons/modules/vif.svg';
import icons__operations__add from './icons/operations/add.svg';
import icons__operations__div from './icons/operations/div.svg';
import icons__operations__mul from './icons/operations/mul.svg';
import icons__operations__sub from './icons/operations/sub.svg';
import icons__shapes__circle from './icons/shapes/circle.svg';
import icons__shapes__rectangle from './icons/shapes/rectangle.svg';
import icons__shapes__square from './icons/shapes/square.svg';
import icons__shapes__triangle from './icons/shapes/triangle.svg';
import icons__stages_of_learning__get_it from './icons/stages-of-learning/get-it.svg';
import icons__stages_of_learning__got_it from './icons/stages-of-learning/got-it.svg';
import icons__stages_of_learning__own_it from './icons/stages-of-learning/own-it.svg';
import icons__stages_of_learning__use_it from './icons/stages-of-learning/use-it.svg';
import icons__stages_of_learning from './icons/stages-of-learning.svg';
import icons__top_games from './icons/top-games.svg';
import icons__under_construction from './icons/under-construction.svg';
import icons__unit_systems__metric from './icons/unit-systems/metric.svg';
import icons__unit_systems__mixed from './icons/unit-systems/mixed.svg';
import icons__unit_systems__us from './icons/unit-systems/us.svg';

export const icons = {
  'algebra-readiness': icons__algebra_readiness,
  'alts/gym-add': icons__alts__gym_add,
  'alts/gym-dec-add': icons__alts__gym_dec_add,
  'alts/gym-dec-div': icons__alts__gym_dec_div,
  'alts/gym-dec-mul': icons__alts__gym_dec_mul,
  'alts/gym-dec-sub': icons__alts__gym_dec_sub,
  'alts/gym-dec': icons__alts__gym_dec,
  'alts/gym-div': icons__alts__gym_div,
  'alts/gym-frc-add': icons__alts__gym_frc_add,
  'alts/gym-frc-div': icons__alts__gym_frc_div,
  'alts/gym-frc-mul': icons__alts__gym_frc_mul,
  'alts/gym-frc-sub': icons__alts__gym_frc_sub,
  'alts/gym-frc': icons__alts__gym_frc,
  'alts/gym-int-add': icons__alts__gym_int_add,
  'alts/gym-int-div': icons__alts__gym_int_div,
  'alts/gym-int-mul': icons__alts__gym_int_mul,
  'alts/gym-int-sub': icons__alts__gym_int_sub,
  'alts/gym-int': icons__alts__gym_int,
  'alts/gym-k2-add': icons__alts__gym_k2_add,
  'alts/gym-k2-sub': icons__alts__gym_k2_sub,
  'alts/gym-mul': icons__alts__gym_mul,
  'alts/gym-num-add': icons__alts__gym_num_add,
  'alts/gym-num-div': icons__alts__gym_num_div,
  'alts/gym-num-mul': icons__alts__gym_num_mul,
  'alts/gym-num-sub': icons__alts__gym_num_sub,
  'alts/gym-num': icons__alts__gym_num,
  'alts/gym-sub': icons__alts__gym_sub,
  'alts/jtf-add': icons__alts__jtf_add,
  'alts/jtf-div': icons__alts__jtf_div,
  'alts/jtf-mul': icons__alts__jtf_mul,
  'alts/jtf-sub': icons__alts__jtf_sub,
  'alts/ss1-g1': icons__alts__ss1_g1,
  'alts/ss1-g2': icons__alts__ss1_g2,
  'alts/ss1-g3': icons__alts__ss1_g3,
  'alts/ss2-g1': icons__alts__ss2_g1,
  'alts/ss2-g2': icons__alts__ss2_g2,
  'alts/ss2-g3': icons__alts__ss2_g3,
  'alts/ss3-g1': icons__alts__ss3_g1,
  'alts/ss3-g2': icons__alts__ss3_g2,
  'alts/ss3-g3': icons__alts__ss3_g3,
  'alts/ss4-g1': icons__alts__ss4_g1,
  'alts/ss4-g2': icons__alts__ss4_g2,
  'alts/ss4-g3': icons__alts__ss4_g3,
  'alts/ss5-g1': icons__alts__ss5_g1,
  'alts/ss5-g2': icons__alts__ss5_g2,
  'alts/ss5-g3': icons__alts__ss5_g3,
  'alts/ss6-g1': icons__alts__ss6_g1,
  'alts/ss6-g2': icons__alts__ss6_g2,
  'alts/ss6-g3': icons__alts__ss6_g3,
  'alts/ss7-g1': icons__alts__ss7_g1,
  'alts/ss7-g2': icons__alts__ss7_g2,
  'alts/ss7-g3': icons__alts__ss7_g3,
  'alts/ss8-g1': icons__alts__ss8_g1,
  'alts/ss8-g2': icons__alts__ss8_g2,
  'alts/ss8-g3': icons__alts__ss8_g3,
  'alts/vif-add': icons__alts__vif_add,
  'alts/vif-div': icons__alts__vif_div,
  'alts/vif-mul': icons__alts__vif_mul,
  'alts/vif-sub': icons__alts__vif_sub,
  compass: icons__compass,
  fim: icons__fim,
  'fractions-fest': icons__fractions_fest,
  'games/24-wheels': icons__games__24_wheels,
  'games/3-moves-to-0-quantum': icons__games__3_moves_to_0_quantum,
  'games/3-moves-to-0': icons__games__3_moves_to_0,
  'games/3-to-9-add': icons__games__3_to_9_add,
  'games/3-to-9-sub': icons__games__3_to_9_sub,
  'games/abc': icons__games__abc,
  'games/algebra-mol': icons__games__algebra_mol,
  'games/algebra-tiles': icons__games__algebra_tiles,
  'games/alphabet': icons__games__alphabet,
  'games/area-perimeter': icons__games__area_perimeter,
  'games/building-sentences': icons__games__building_sentences,
  'games/cb-sounds': icons__games__cb_sounds,
  'games/change-one-letter': icons__games__change_one_letter,
  'games/consonant-blends': icons__games__consonant_blends,
  'games/decimal-tiles': icons__games__decimal_tiles,
  'games/decimals-mol': icons__games__decimals_mol,
  'games/deep-seaquence-lvl1': icons__games__deep_seaquence_lvl1,
  'games/deep-seaquence-lvl2': icons__games__deep_seaquence_lvl2,
  'games/deep-seaquence': icons__games__deep_seaquence,
  'games/early-algebra-tiles': icons__games__early_algebra_tiles,
  'games/elementary-algebra-tiles': icons__games__elementary_algebra_tiles,
  'games/epic-circles': icons__games__epic_circles,
  'games/equal-length': icons__games__equal_length,
  'games/equal-pay-dollars': icons__games__equal_pay_dollars,
  'games/equal-pay-rupees': icons__games__equal_pay_rupees,
  'games/equal-pay': icons__games__equal_pay,
  'games/equal-time': icons__games__equal_time,
  'games/equal-weight': icons__games__equal_weight,
  'games/equivalent-fraction-tiles': icons__games__equivalent_fraction_tiles,
  'games/equivalents-lvl1': icons__games__equivalents_lvl1,
  'games/equivalents-lvl2': icons__games__equivalents_lvl2,
  'games/equivalents': icons__games__equivalents,
  'games/estimation-dec-epic': icons__games__estimation_dec_epic,
  'games/estimation-dec-newb': icons__games__estimation_dec_newb,
  'games/estimation-dec': icons__games__estimation_dec,
  'games/estimation-epic': icons__games__estimation_epic,
  'games/estimation-newb': icons__games__estimation_newb,
  'games/estimation': icons__games__estimation,
  'games/exponent-tiles': icons__games__exponent_tiles,
  'games/factor-wheels-ct': icons__games__factor_wheels_ct,
  'games/factor-wheels': icons__games__factor_wheels,
  'games/finding-words-4x4': icons__games__finding_words_4x4,
  'games/first-in-tens-add': icons__games__first_in_tens_add,
  'games/first-in-tens-sub': icons__games__first_in_tens_sub,
  'games/first-to-twenty-add': icons__games__first_to_twenty_add,
  'games/first-to-twenty-sub': icons__games__first_to_twenty_sub,
  'games/five-at-a-time': icons__games__five_at_a_time,
  'games/fraction-tiles': icons__games__fraction_tiles,
  'games/fraction-wheels': icons__games__fraction_wheels,
  'games/fractions-mol': icons__games__fractions_mol,
  'games/gems-to-zero': icons__games__gems_to_zero,
  'games/geometry-tiles': icons__games__geometry_tiles,
  'games/grand-slam-add-sub': icons__games__grand_slam_add_sub,
  'games/grand-slam-alg': icons__games__grand_slam_alg,
  'games/grand-slam-dec-add-sub': icons__games__grand_slam_dec_add_sub,
  'games/grand-slam-dec-all': icons__games__grand_slam_dec_all,
  'games/grand-slam-dec-mul-div': icons__games__grand_slam_dec_mul_div,
  'games/grand-slam-dec': icons__games__grand_slam_dec,
  'games/grand-slam-frc-add-sub': icons__games__grand_slam_frc_add_sub,
  'games/grand-slam-frc-all': icons__games__grand_slam_frc_all,
  'games/grand-slam-frc-mul-div': icons__games__grand_slam_frc_mul_div,
  'games/grand-slam-frc': icons__games__grand_slam_frc,
  'games/grand-slam-integers': icons__games__grand_slam_integers,
  'games/grand-slam-mul-div': icons__games__grand_slam_mul_div,
  'games/hex-factor-lvl1': icons__games__hex_factor_lvl1,
  'games/hex-factor-lvl2': icons__games__hex_factor_lvl2,
  'games/high-fq-words': icons__games__high_fq_words,
  'games/integer-tiles': icons__games__integer_tiles,
  'games/into-the-vortex': icons__games__into_the_vortex,
  'games/jennies-jewels': icons__games__jennies_jewels,
  'games/jeweled-tiles': icons__games__jeweled_tiles,
  'games/k2-before-and-after': icons__games__k2_before_and_after,
  'games/k2-ct': icons__games__k2_ct,
  'games/k2-five-at-a-time': icons__games__k2_five_at_a_time,
  'games/k2-four-at-a-time': icons__games__k2_four_at_a_time,
  'games/k2-how-many': icons__games__k2_how_many,
  'games/k2-jennies-jewels': icons__games__k2_jennies_jewels,
  'games/k2-misfits-num-ct': icons__games__k2_misfits_num_ct,
  'games/k2-misfits-num': icons__games__k2_misfits_num,
  'games/k2-misfits': icons__games__k2_misfits,
  'games/k2-missing-icons-ct': icons__games__k2_missing_icons_ct,
  'games/k2-mol': icons__games__k2_mol,
  'games/k2-monus-path-ct': icons__games__k2_monus_path_ct,
  'games/k2-pundis-puzzle-ct': icons__games__k2_pundis_puzzle_ct,
  'games/k2-pundis-puzzle': icons__games__k2_pundis_puzzle,
  'games/k2-rps-ct': icons__games__k2_rps_ct,
  'games/k2-rps': icons__games__k2_rps,
  'games/k2-skip-game': icons__games__k2_skip_game,
  'games/k2-triplets': icons__games__k2_triplets,
  'games/k2-undo': icons__games__k2_undo,
  'games/k2-what-belongs-ct': icons__games__k2_what_belongs_ct,
  'games/letter-memory': icons__games__letter_memory,
  'games/link-n-lock-as': icons__games__link_n_lock_as,
  'games/link-n-lock-frc': icons__games__link_n_lock_frc,
  'games/link-n-lock-jewels': icons__games__link_n_lock_jewels,
  'games/link-n-lock-md': icons__games__link_n_lock_md,
  'games/link-n-lock-mosaic': icons__games__link_n_lock_mosaic,
  'games/making-change-rupees': icons__games__making_change_rupees,
  'games/making-change': icons__games__making_change,
  'games/matching-letters': icons__games__matching_letters,
  'games/misfits-37-num': icons__games__misfits_37_num,
  'games/misfits-37': icons__games__misfits_37,
  'games/misfits-dec': icons__games__misfits_dec,
  'games/misfits-frc': icons__games__misfits_frc,
  'games/misfits-master': icons__games__misfits_master,
  'games/misfits-newb': icons__games__misfits_newb,
  'games/misfits-num': icons__games__misfits_num,
  'games/misfits-spelling': icons__games__misfits_spelling,
  'games/misfits': icons__games__misfits,
  'games/missing-letters': icons__games__missing_letters,
  'games/mol-lvl1': icons__games__mol_lvl1,
  'games/mol-lvl2': icons__games__mol_lvl2,
  'games/mol': icons__games__mol,
  'games/money-tiles': icons__games__money_tiles,
  'games/monujis-path': icons__games__monujis_path,
  'games/monus-path': icons__games__monus_path,
  'games/number-circles': icons__games__number_circles,
  'games/numbers-k2': icons__games__numbers_k2,
  'games/order-of-operations-tiles': icons__games__order_of_operations_tiles,
  'games/passing-time': icons__games__passing_time,
  'games/pattern-power': icons__games__pattern_power,
  'games/pattern-puzzle': icons__games__pattern_puzzle,
  'games/phonemes-alpha': icons__games__phonemes_alpha,
  'games/phonemes-pi': icons__games__phonemes_pi,
  'games/pk-before-and-after': icons__games__pk_before_and_after,
  'games/pk-how-many': icons__games__pk_how_many,
  'games/pk-memory-tiles': icons__games__pk_memory_tiles,
  'games/pk-missing-icons': icons__games__pk_missing_icons,
  'games/pk-mol': icons__games__pk_mol,
  'games/pk-three-at-a-time': icons__games__pk_three_at_a_time,
  'games/pundis-puzzle': icons__games__pundis_puzzle,
  'games/quantum-algebra': icons__games__quantum_algebra,
  'games/rhyme-time': icons__games__rhyme_time,
  'games/rps-master': icons__games__rps_master,
  'games/rps-newb-ct': icons__games__rps_newb_ct,
  'games/rps': icons__games__rps,
  'games/see-3': icons__games__see_3,
  'games/shape-shuffle': icons__games__shape_shuffle,
  'games/shapes-k2': icons__games__shapes_k2,
  'games/skip-game': icons__games__skip_game,
  'games/sound-of-letters': icons__games__sound_of_letters,
  'games/speed-shuffle': icons__games__speed_shuffle,
  'games/sub-all': icons__games__sub_all,
  'games/ten-wheels-elite': icons__games__ten_wheels_elite,
  'games/ten-wheels': icons__games__ten_wheels,
  'games/the-hex-factor': icons__games__the_hex_factor,
  'games/time-more-or-less': icons__games__time_more_or_less,
  'games/touchdown-100-add': icons__games__touchdown_100_add,
  'games/touchdown-100-sub': icons__games__touchdown_100_sub,
  'games/undo-fractions': icons__games__undo_fractions,
  'games/verb-tenses': icons__games__verb_tenses,
  'games/vif-tiles': icons__games__vif_tiles,
  'games/word-wheels': icons__games__word_wheels,
  'games/write-a-sentence': icons__games__write_a_sentence,
  'games/xtreme-algebra': icons__games__xtreme_algebra,
  'games/xyz-shuffle': icons__games__xyz_shuffle,
  'games/zero-sum-newb': icons__games__zero_sum_newb,
  'games/zero-sum': icons__games__zero_sum,
  'gym-numbers/dec/0-05': icons__gym_numbers__dec__0_05,
  'gym-numbers/dec/0-1': icons__gym_numbers__dec__0_1,
  'gym-numbers/dec/0-2': icons__gym_numbers__dec__0_2,
  'gym-numbers/dec/0-25': icons__gym_numbers__dec__0_25,
  'gym-numbers/dec/0-3': icons__gym_numbers__dec__0_3,
  'gym-numbers/dec/0-4': icons__gym_numbers__dec__0_4,
  'gym-numbers/dec/0-5': icons__gym_numbers__dec__0_5,
  'gym-numbers/dec/0-6': icons__gym_numbers__dec__0_6,
  'gym-numbers/dec/0-7': icons__gym_numbers__dec__0_7,
  'gym-numbers/dec/0-75': icons__gym_numbers__dec__0_75,
  'gym-numbers/dec/0-8': icons__gym_numbers__dec__0_8,
  'gym-numbers/dec/0-9': icons__gym_numbers__dec__0_9,
  'gym-numbers/frc/1-16': icons__gym_numbers__frc__1_16,
  'gym-numbers/frc/1-2': icons__gym_numbers__frc__1_2,
  'gym-numbers/frc/1-3': icons__gym_numbers__frc__1_3,
  'gym-numbers/frc/1-32': icons__gym_numbers__frc__1_32,
  'gym-numbers/frc/1-4': icons__gym_numbers__frc__1_4,
  'gym-numbers/frc/1-5': icons__gym_numbers__frc__1_5,
  'gym-numbers/frc/1-8': icons__gym_numbers__frc__1_8,
  'gym-numbers/frc/2-3': icons__gym_numbers__frc__2_3,
  'gym-numbers/frc/3-4': icons__gym_numbers__frc__3_4,
  'gym-numbers/frc/3-8': icons__gym_numbers__frc__3_8,
  'gym-numbers/frc/5-8': icons__gym_numbers__frc__5_8,
  'gym-numbers/frc/7-8': icons__gym_numbers__frc__7_8,
  'gym-numbers/int/neg-1': icons__gym_numbers__int__neg_1,
  'gym-numbers/int/neg-10': icons__gym_numbers__int__neg_10,
  'gym-numbers/int/neg-11': icons__gym_numbers__int__neg_11,
  'gym-numbers/int/neg-12': icons__gym_numbers__int__neg_12,
  'gym-numbers/int/neg-2': icons__gym_numbers__int__neg_2,
  'gym-numbers/int/neg-3': icons__gym_numbers__int__neg_3,
  'gym-numbers/int/neg-4': icons__gym_numbers__int__neg_4,
  'gym-numbers/int/neg-5': icons__gym_numbers__int__neg_5,
  'gym-numbers/int/neg-6': icons__gym_numbers__int__neg_6,
  'gym-numbers/int/neg-7': icons__gym_numbers__int__neg_7,
  'gym-numbers/int/neg-8': icons__gym_numbers__int__neg_8,
  'gym-numbers/int/neg-9': icons__gym_numbers__int__neg_9,
  'gym-numbers/num/1': icons__gym_numbers__num__1,
  'gym-numbers/num/10': icons__gym_numbers__num__10,
  'gym-numbers/num/11': icons__gym_numbers__num__11,
  'gym-numbers/num/12': icons__gym_numbers__num__12,
  'gym-numbers/num/2': icons__gym_numbers__num__2,
  'gym-numbers/num/3': icons__gym_numbers__num__3,
  'gym-numbers/num/4': icons__gym_numbers__num__4,
  'gym-numbers/num/5': icons__gym_numbers__num__5,
  'gym-numbers/num/6': icons__gym_numbers__num__6,
  'gym-numbers/num/7': icons__gym_numbers__num__7,
  'gym-numbers/num/8': icons__gym_numbers__num__8,
  'gym-numbers/num/9': icons__gym_numbers__num__9,
  'ks-categories/1': icons__ks_categories__1,
  'ks-categories/2': icons__ks_categories__2,
  'ks-categories/3': icons__ks_categories__3,
  'ks-categories/4': icons__ks_categories__4,
  'ks-categories/5': icons__ks_categories__5,
  'ks-categories/6': icons__ks_categories__6,
  'ks-categories/7': icons__ks_categories__7,
  'ks-categories/8': icons__ks_categories__8,
  'ks-categories/9': icons__ks_categories__9,
  lock: icons__lock,
  'math-objectives': icons__math_objectives,
  'modes/dec': icons__modes__dec,
  'modes/frc': icons__modes__frc,
  'modes/int': icons__modes__int,
  'modes/k2': icons__modes__k2,
  'modes/num': icons__modes__num,
  'modules/bonus': icons__modules__bonus,
  'modules/bonus/bonus-1': icons__modules__bonus__bonus_1,
  'modules/bonus/bonus-2': icons__modules__bonus__bonus_2,
  'modules/bonus/bonus-3': icons__modules__bonus__bonus_3,
  'modules/bonus/bonus-4': icons__modules__bonus__bonus_4,
  'modules/bonus/bonus-5': icons__modules__bonus__bonus_5,
  'modules/bonus/bonus-6': icons__modules__bonus__bonus_6,
  'modules/bonus/bonus-7': icons__modules__bonus__bonus_7,
  'modules/bonus/bonus-8': icons__modules__bonus__bonus_8,
  'modules/ct': icons__modules__ct,
  'modules/gyms': icons__modules__gyms,
  'modules/jtf': icons__modules__jtf,
  'modules/k2': icons__modules__k2,
  'modules/k2/first-in-reading': icons__modules__k2__first_in_reading,
  'modules/k2/first-in-reading/letters':
    icons__modules__k2__first_in_reading__letters,
  'modules/k2/first-in-reading/sentences':
    icons__modules__k2__first_in_reading__sentences,
  'modules/k2/first-in-reading/words':
    icons__modules__k2__first_in_reading__words,
  'modules/k2/pre-k': icons__modules__k2__pre_k,
  'modules/ks': icons__modules__ks,
  'modules/ks/ks-1': icons__modules__ks__ks_1,
  'modules/ks/ks-2': icons__modules__ks__ks_2,
  'modules/ks/ks-3': icons__modules__ks__ks_3,
  'modules/ks/ks-4': icons__modules__ks__ks_4,
  'modules/ks/ks-5': icons__modules__ks__ks_5,
  'modules/ks/ks-6': icons__modules__ks__ks_6,
  'modules/ks/ks-7': icons__modules__ks__ks_7,
  'modules/ks/ks-8': icons__modules__ks__ks_8,
  'modules/mw': icons__modules__mw,
  'modules/ss': icons__modules__ss,
  'modules/ss/g1': icons__modules__ss__g1,
  'modules/ss/g2': icons__modules__ss__g2,
  'modules/ss/g3': icons__modules__ss__g3,
  'modules/ss/ss-1': icons__modules__ss__ss_1,
  'modules/ss/ss-2': icons__modules__ss__ss_2,
  'modules/ss/ss-3': icons__modules__ss__ss_3,
  'modules/ss/ss-4': icons__modules__ss__ss_4,
  'modules/ss/ss-5': icons__modules__ss__ss_5,
  'modules/ss/ss-6': icons__modules__ss__ss_6,
  'modules/ss/ss-7': icons__modules__ss__ss_7,
  'modules/ss/ss-8': icons__modules__ss__ss_8,
  'modules/vif': icons__modules__vif,
  'operations/add': icons__operations__add,
  'operations/div': icons__operations__div,
  'operations/mul': icons__operations__mul,
  'operations/sub': icons__operations__sub,
  'shapes/circle': icons__shapes__circle,
  'shapes/rectangle': icons__shapes__rectangle,
  'shapes/square': icons__shapes__square,
  'shapes/triangle': icons__shapes__triangle,
  'stages-of-learning': icons__stages_of_learning,
  'stages-of-learning/get-it': icons__stages_of_learning__get_it,
  'stages-of-learning/got-it': icons__stages_of_learning__got_it,
  'stages-of-learning/own-it': icons__stages_of_learning__own_it,
  'stages-of-learning/use-it': icons__stages_of_learning__use_it,
  'top-games': icons__top_games,
  'under-construction': icons__under_construction,
  'unit-systems/metric': icons__unit_systems__metric,
  'unit-systems/mixed': icons__unit_systems__mixed,
  'unit-systems/us': icons__unit_systems__us,
};

export type IconKey = keyof typeof icons;
